import { useQuery } from "@tanstack/react-query";
import { MoreVert } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import { getVehicles } from "services/vehicle";
import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import PriceForm from "./PriceForm";

const VehicleTable = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [openPriceDialog, setOpenPriceDialog] = useState(false);

  const { data, isLoading } = useQuery({
    queryKey: ["vehicles"],
    queryFn: getVehicles,
  });

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    vehicle: any,
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedVehicle(vehicle);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    //   setSelectedVehicle(null);
  };

  const handleAddPrice = () => {
    handleMenuClose();
    setOpenPriceDialog(true);
  };

  const handleClosePriceDialog = () => {
    setOpenPriceDialog(false);
    // setSelectedVehicle(null);
  };

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  console.log(selectedVehicle, openPriceDialog);

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 4, boxShadow: "none" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFB" }}>
              <TableCell sx={{ fontWeight: 600 }}>Vehicle</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Color</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Seats</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Image</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.data?.map((vehicle: any) => (
              <TableRow key={vehicle._id}>
                <TableCell>{vehicle.name}</TableCell>
                <TableCell>{vehicle.type}</TableCell>
                <TableCell>{vehicle.color}</TableCell>
                <TableCell>{vehicle.seats}</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      backgroundColor: vehicle.availability
                        ? "#ECFDF3"
                        : "#FEF3F2",
                      color: vehicle.availability ? "#027A48" : "#B42318",
                      borderRadius: "16px",
                      px: 2,
                      py: 0.5,
                      display: "inline-block",
                    }}
                  >
                    {vehicle.availability ? "Available" : "Not Available"}
                  </Box>
                </TableCell>
                <TableCell>
                  {vehicle.front_image && (
                    <img
                      src={vehicle.front_image}
                      alt={vehicle.name}
                      style={{
                        width: "40px",
                        height: "40px",
                        maxWidth: "40px",
                        maxHeight: "40px",
                        objectFit: "cover",
                        borderRadius: "4px",
                      }}
                    />
                  )}
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={(e) => handleMenuOpen(e, vehicle)}
                    size="small"
                  >
                    <MoreVert />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
              mt: 1,
            },
          }}
        >
          <MenuItem
            onClick={handleAddPrice}
            sx={{
              fontSize: "14px",
              py: 1,
              px: 2,
            }}
          >
            Add Price
          </MenuItem>
          {/* <MenuItem
            onClick={handleEdit}
            sx={{
              fontSize: "14px",
              py: 1,
              px: 2,
            }}
          >
            Edit Vehicle
          </MenuItem>
          <MenuItem
            onClick={handleDelete}
            sx={{
              fontSize: "14px",
              py: 1,
              px: 2,
              color: "#B42318",
            }}
          >
            Delete Vehicle
          </MenuItem> */}
        </Menu>
      </TableContainer>

      <Dialog
        open={openPriceDialog}
        onClose={handleClosePriceDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#333",
            borderBottom: "1px solid #E4E7EC",
            p: 2,
          }}
        >
          Add Vehicle Price
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {selectedVehicle && (
            <>
              <Typography sx={{ color: "#344054", mb: 2 }}>
                Setting price for: {selectedVehicle.name}
              </Typography>
              <PriceForm
                vehicleId={selectedVehicle._id}
                onSuccess={handleClosePriceDialog}
              />
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default VehicleTable;
